import { PaymentMethod } from '../../interfaces';
import {
    ALIPAY,
    APPLE_PAY,
    BANCOMAT_PAY,
    BANCONTACT_QR_CODE,
    BIT_PAY,
    BLIK,
    BLIK_DIRECT,
    BLUE_CODE,
    CARD_PRESENT,
    CASH,
    CLICK_TO_PAY,
    CREDIT_CARD,
    DIAS,
    DIRECT_DEBIT,
    DIRECT_PAY,
    EPS,
    GIRO_PAY,
    GIRO_PAY_DIRECT,
    GOOGLE_PAY,
    IDEAL,
    IRIS,
    KLARNA,
    MOBILE_PAY,
    MULTIBANCO,
    MULTIBANCO_REFERENCE,
    MULTIBANCO_WAY,
    P24,
    PAYCONIQ,
    PAY_PAL,
    PAYMENT_INITIATION,
    PAY_ON_DELIVERY,
    PAYU,
    PREAUTH_CAPTURE,
    SAMSUNG_PAY,
    SATISPAY,
    SWISH,
    TBI_BNPL,
    TRUSTLY,
    WALLET,
    WE_CHAT_PAY,
    WERO
} from '../methods';

export const DEFAULT_PAYMENT_METHOD_GROUP: Array<PaymentMethod> = [
    ALIPAY,
    APPLE_PAY,
    BANCOMAT_PAY,
    BANCONTACT_QR_CODE,
    BIT_PAY,
    BLIK,
    BLIK_DIRECT,
    BLUE_CODE,
    CARD_PRESENT,
    CASH,
    CLICK_TO_PAY,
    CREDIT_CARD,
    DIAS,
    DIRECT_DEBIT,
    DIRECT_PAY,
    EPS,
    GIRO_PAY,
    GIRO_PAY_DIRECT,
    GOOGLE_PAY,
    IDEAL,
    IRIS,
    KLARNA,
    MOBILE_PAY,
    MULTIBANCO,
    MULTIBANCO_REFERENCE,
    MULTIBANCO_WAY,
    P24,
    PAYCONIQ,
    PAY_PAL,
    PAYMENT_INITIATION,
    PAY_ON_DELIVERY,
    PAYU,
    PREAUTH_CAPTURE,
    SAMSUNG_PAY,
    SATISPAY,
    SWISH,
    TBI_BNPL,
    TRUSTLY,
    WALLET,
    WE_CHAT_PAY,
    WERO
];
